document.addEventListener("DOMContentLoaded", () => {
  // Check IP location
  // --------------
  var country_name,
    country_code,
    retryCount = 0;

  function checkLocation() {
    retryCount++;

    // Prevent request loop
    if (retryCount > 3) {
      return false;
    }

    fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        country_name = data.detected_values.country.name;
        country_code = data.detected_values.country.handle;
        sessionStorage.setItem("country_name", country_name);
        sessionStorage.setItem("country_code", country_code);
        runLocationScripts();
      })
      .catch((err) => {
        return;
      });
  }

  function runLocationScripts() {
    country_name = sessionStorage.getItem("country_name");
    country_code = sessionStorage.getItem("country_code");

    if (!country_code || !country_name) {
      // If no location exists, run location check
      checkLocation();
    } else {
      document.documentElement.classList.add(
        "geo-code",
        `geo-code-${country_code.toLowerCase()}`
      );
    }
  }
  runLocationScripts();
});
